import { useEffect, useMemo, useState } from 'react';

export const useSmoothSlider = (optionsList: any[], value: number | null, valueName: string) => {
	const [sliderValue, setSliderValue] = useState<number>(0);

	useEffect(() => {
		setSliderValue((optionsList.length !== 0 ? optionsList.findIndex(item => item[valueName] === value) : 0) * 100);
	}, [value, optionsList, valueName]);

	const sliderProps = useMemo(
		() => ({
			minLabel: optionsList[0]?.[valueName] || 1,
			maxLabel: optionsList[optionsList.length - 1]?.[valueName] || 1,
			min: 0,
			max: (optionsList.length - 1) * 100,
		}),
		[optionsList, valueName],
	);

	return { sliderValue, setSliderValue, sliderProps };
};
